"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firstWordToLowerCase = exports.addPrefix = void 0;

const addPrefix = (prefix, value) => String(prefix).concat(value);

exports.addPrefix = addPrefix;

const firstWordToLowerCase = value => {
  if (value.length >= 1) {
    return value[0].toLowerCase() + value.slice(1, value.length);
  }

  return value;
};

exports.firstWordToLowerCase = firstWordToLowerCase;